export default __webpack_public_path__ + "static/worksans-mediumitalic-webfont-a4f3d929830f970cfcf30bd6317f1dae.woff2";